/**
 * @file     ListingMortgageState.tsx
 * @readme   ../../CLAUDE.md
 * @purpose  Shared client state for the listing mortgage tab and sticky rail.
 */
'use client';

import { createContext, useContext, useState, type Dispatch, type ReactNode, type SetStateAction } from 'react';
import { MORTGAGE_DEFAULTS } from '@/features/mortgage-calculator-flow/types';

export interface ListingMortgageStateValue {
  downPct: number;
  setDownPct: Dispatch<SetStateAction<number>>;
  rate: number;
  setRate: Dispatch<SetStateAction<number>>;
  rateInput: string;
  setRateInput: Dispatch<SetStateAction<string>>;
  amortization: 25 | 30;
  setAmortization: Dispatch<SetStateAction<25 | 30>>;
  brokerIndex: number;
  setBrokerIndex: Dispatch<SetStateAction<number>>;
}

const ListingMortgageStateContext = createContext<ListingMortgageStateValue | null>(null);

export function ListingMortgageStateProvider({ children }: { children: ReactNode }) {
  const [downPct, setDownPct] = useState(20);
  const [rate, setRate] = useState(MORTGAGE_DEFAULTS.interestRate);
  const [rateInput, setRateInput] = useState(String(MORTGAGE_DEFAULTS.interestRate));
  const [amortization, setAmortization] = useState<25 | 30>(25);
  const [brokerIndex, setBrokerIndex] = useState(0);

  return (
    <ListingMortgageStateContext.Provider value={{
      downPct,
      setDownPct,
      rate,
      setRate,
      rateInput,
      setRateInput,
      amortization,
      setAmortization,
      brokerIndex,
      setBrokerIndex,
    }}>
      {children}
    </ListingMortgageStateContext.Provider>
  );
}

export function useListingMortgageState(): ListingMortgageStateValue | null {
  return useContext(ListingMortgageStateContext);
}
